/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_TitleInputs */

const en_to_yaml_title = /** @type {(inputs: To_Yaml_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON to YAML Converter`)
};

const ko_to_yaml_title = /** @type {(inputs: To_Yaml_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON → YAML 변환기`)
};

const ja_to_yaml_title = /** @type {(inputs: To_Yaml_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON → YAML変換ツール`)
};

/**
* | output |
* | --- |
* | "JSON to YAML Converter" |
*
* @param {To_Yaml_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_title = /** @type {((inputs?: To_Yaml_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_title(inputs)
	if (locale === "ko") return ko_to_yaml_title(inputs)
	return ja_to_yaml_title(inputs)
});